export default __webpack_public_path__ + "static/media/scrollcard4.f2bfe0ec.jpg";